<script>
    import { SvelteFlowProvider } from '@xyflow/svelte';
    import ResearchFlow from './ResearchFlow.svelte';

    // Provider wraps the flow so ResearchFlow can use useSvelteFlow()
    // (screenToFlowPosition for toolbar card drops).
    let props = $props();
</script>

<SvelteFlowProvider>
    <ResearchFlow {...props} />
</SvelteFlowProvider>
